import React from "react";

const IconError = () => {
  return (
    <svg width="108" height="59" viewBox="0 0 108 59" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 56.25H0" stroke="#EC111A" stroke-width="2"/>
    <path d="M55 58.75C65.4934 58.75 74 57.6307 74 56.25C74 54.8693 65.4934 53.75 55 53.75C44.5066 53.75 36 54.8693 36 56.25C36 57.6307 44.5066 58.75 55 58.75Z" fill="#F6F6F6"/>
    <path d="M108 56.25H84" stroke="#EC111A" stroke-width="2"/>
    <path d="M30 23.5233V24.2286C30.1937 37.3447 40.9325 47.8481 54.0496 47.7512C67.1668 47.6543 77.7492 36.9934 77.7492 23.8759C77.7492 10.7584 67.1668 0.0975417 54.0496 0.000664788C40.9325 -0.0962121 30.1937 10.4072 30 23.5233Z" fill="#EC111A"/>
    <path d="M46.1172 16.1328L60.9025 30.9181" stroke="white" stroke-width="5.33333" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M60.9025 16.1328L46.1172 30.9181" stroke="white" stroke-width="5.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    

  );
};
export default IconError;
